<template src="./PaginateComponent.html"></template>
<script>
import {computed, ref, watch} from "vue";
import {usePartnerStore} from "@/stores/partner.js";

export default {
  name: 'PaginateComponent',
  props: {
    paginate: {
      type: Object,
      required: false,
      default: () => {}
    },
    urlOrigin: {
      type: String,
      required: false,
      default: () => ''
    },
  },
  emits: ['page'],
  setup(props, { emit }) {
    const paginate_current = ref(props.paginate)
    const partnerStore = usePartnerStore()
    const urlOrigin = props.urlOrigin

    watch(() => props.paginate, (newPaginate) => {
      paginate_current.value = newPaginate
    });
    const linkPrevPage = computed(() => {
      const urlPrev = urlOrigin + (parseInt(paginate_current.value?.page) <= 2 ? '' : ('?page=' + (parseInt(paginate_current.value.page) - 1)));
      return paginate_current.value.hasPreviousPage ? urlPrev : 'javascript:void(0)';
    })
    const linkNextPage = computed(() => {
      const urlNext = urlOrigin + '?page=' + (parseInt(paginate_current.value.page) + 1);
      return paginate_current.value.hasNextPage ? urlNext : 'javascript:void(0)';
    })

    const counterPage = computed(() => {
      return paginate_current.value.pageCount;
    })

    function setPage(page) {
      emit('page', page)
    }
    return {
      paginate_current,
      linkPrevPage,
      linkNextPage,
      counterPage,
      partnerStore,
      setPage,
    }
  }
}
</script>
<style scoped lang="scss">
.paginate {
  padding: 50px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  $main-color: #f0f0f0;
  $secondary-color: #1d1f20;
  @mixin display-child($n) {
    @for $i from 2 through $n {
      &:nth-child(#{$i}) {
        a {
          display: inline-block;
        }
      }
    }
  }
  .pagination {
    justify-content: center;
    ul, li {
      list-style: none;
      display: inline;
      padding-left: 0;
    }
    li {
      margin: 0;
      counter-increment: pagination;
      &:hover {
        a {
          color: lighten($main-color, 5%);
          background-color: $secondary-color;
          border: solid 1px $secondary-color;
        }
      }
      &.active {
        a {
          color: lighten($main-color, 5%);
          background-color: $secondary-color;
          border: solid 1px $secondary-color;
        }
      }
      &:first-child {
        float: left;
        a {
          &:after {
            content: "Previous";
          }
        }
      }
      &:nth-child(2) {
        counter-reset: pagination;
      }
      &:last-child {
        float: right;
        a {
          &:after {
            content: "Next";
          }
        }
      }
      a {
        border: solid 1px darken($main-color, 10%);
        border-radius: 0.2rem;
        color: darken($main-color, 45%);
        text-decoration: none;
        text-transform: uppercase;
        display: inline-block;
        text-align: center;
        padding: 0.5rem 0.9rem;
      }
    }
    li {
      a {
        display: none;
      }
      &:first-child {
        a {
          display: inline-block;
        }
        a:after {
          content: "<";
        }
      }
      @include display-child(8);
      &:last-child {
        a {
          display: inline-block;
        }
        a:after {
          content: ">";
        }
      }
      &:nth-last-child(2) {
        a {
          display: inline-block;
        }
      }
    }
  }
}
</style>